import { Component, OnInit } from '@angular/core';
import { CommunicationService } from 'src/app/services/Communication/communication.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-communcation-document',
  templateUrl: './communcation-document.component.html',
  styleUrls: ['./communcation-document.component.css']
})
export class CommuncationDocumentComponent implements OnInit {

  Submitted=false;
  DocumentList=[];
  DocumentTypeList=[];

  constructor(private communicationservice: CommunicationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
  
  SaveUpdateModel = {
     DocumentID:0,
     DocumentTypeID: 0,
     DocumentName: '',
     IsActive: true,
}

ClearSave() {
    this.Submitted = false;
    this.SaveUpdateModel.DocumentName = '';
    this.SaveUpdateModel.DocumentTypeID = 0;
    this.SaveUpdateModel.DocumentID = 0;
};

Edit(item) {
    this.SaveUpdateModel.DocumentID = item.DocumentID;
    this.SaveUpdateModel.DocumentTypeID = item.DocumentTypeID;
    this.SaveUpdateModel.DocumentName = item.DocumentName;
};

ValidityState() {
    return this.SaveUpdateModel.DocumentTypeID == 0;
}

SaveCommDocument(valid) {
    this.Submitted = true;
    if (valid && !this.ValidityState()) {
        this.spinnerService.show();
        this.communicationservice.SaveCommDocument(JSON.stringify(this.SaveUpdateModel)).subscribe((data: any) => {
           this.spinnerService.hide();
           this.globalHelper.CheckActionStatus(data);
            if (this.SaveUpdateModel.DocumentID == 0 && data.webResponse.Status) {
                this.ClearSave();
                this.GetAllCommDocument();
            }
            if (data.webResponse.Status) {
                this.GetAllCommDocument();
            }
             
        });
    }
};


// View

SearchModel = {
   
}

GetAllCommDocument() {
   this.spinnerService.show();
    this.communicationservice.GetAllCommDocument(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
        this.DocumentList = data.DocumentList;
       this.spinnerService.hide();
       this.globalHelper.CheckActionStatus(data);
      
    });
};        


// Active InActive

MarkActive(item) {
    this.SaveUpdateModel.DocumentID = item.DocumentID;
    this.SaveUpdateModel.IsActive = item.IsActive == true ? false : true;
    this.spinnerService.show();
    this.communicationservice.DocumentMarkActive(JSON.stringify(this.SaveUpdateModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {
            this.GetAllCommDocument();
        }
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
    });
}


// Init and Lookup


  ngOnInit() {
    this.GetAllCommDocument();
    this.GetAllDocumentType();
  }

  GetAllDocumentType() {
    this.lookupservice.GetLookupsList('COMMDocumentType', '').subscribe((data: any) => {
        this.DocumentTypeList = data.LookupItems;
    });
};


}

